module.exports = __webpack_public_path__ + "img/hear-icon.42542647.svg";